globalThis.backoffice = globalThis.backoffice || {};

backoffice.AceEditorModule = (function() {
  function AceEditorModule($html) {
    this.$html = $html || $('body');
  }

  AceEditorModule.prototype = {
    getAceEditor: function() {
      utils.require([assets.aceEditor], function() {
        this.textareas = this.$html.find('.ace-editor-textarea');

        this.initAceEditor();
      }.bind(this));
    },
    initAceEditor: function() {
      this.textareas.each(function() {
        var $textarea = $(this);
        var $editor = $textarea.parent().find('.ace-editor');
        var editor = ace.edit($editor.attr('id'));
        var mode = $editor.data('mode') || 'html';
        var editorOptions = $editor.data('ace-editor-options') || {
          minLines: 10,
          maxLines: 25
        }

        editor.getSession().setMode('ace/mode/' + mode);
        editor.setOptions(editorOptions);
        editor.setValue($textarea.text(), 1);
      });
    },
    setAceEditorContentBeforeSubmit: function() {
      this.textareas.each(function() {
        var $textarea = $(this),
            editor = ace.edit($textarea.parent().find('.ace-editor').attr('id'));

        $textarea.text(editor.getValue());
      });
    }
  }

  return AceEditorModule;
})();
